import { render, staticRenderFns } from "./ChatProfessional.vue?vue&type=template&id=5bbb8b28&scoped=true"
import script from "./ChatProfessional.vue?vue&type=script&lang=js"
export * from "./ChatProfessional.vue?vue&type=script&lang=js"
import style0 from "./ChatProfessional.vue?vue&type=style&index=0&id=5bbb8b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb8b28",
  null
  
)

export default component.exports